import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { REMOVE_ORDER_HELP } from '../constants';

/**
 * The ✕ control in a new-order column's header that removes the column.
 *
 * @param {{ label: string, onRemove: () => void, disabled?: boolean }} props `label` is the column's order number, for the accessible name.
 */
export const RemoveOrderButton = ({ label, onRemove, disabled = false }) => (
    <Tooltip title={REMOVE_ORDER_HELP}>
        <span>
            <IconButton size="small" aria-label={`Remove ${label}`} disabled={disabled} onClick={onRemove}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </span>
    </Tooltip>
);

export default RemoveOrderButton;
